export let isFloat = (num: number) => num % 1 > 0;
